// extracted by mini-css-extract-plugin
module.exports = {"form-body":"PrepackageSearch_form-body__kXHzm","search-button":"PrepackageSearch_search-button__kVFCn","search-button--error":"PrepackageSearch_search-button--error__U4_iH"};